import React, { useEffect, useState } from "react";
import PlantillaScreen from "../../../helpers/PlantillaScreen";
import { useHistory } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { LoaderScreen } from "../../../components/LoaderScreen";
import { GetKey } from "../../../Finanzas/Actions/GetContainer";
import { useBox } from "../../../Finanzas/Helper/useBox";
import Swal from "sweetalert2";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import request from "../../../../Helpers/API";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { AgregarMontoGarantiaModal } from "./AgregarMontoGarantiaModal";
import { FormatMoney } from "../../../../Helpers/FormatNumber";
import { CargaMasiva } from "./CargaMasiva";

export const MontosGarantiaScreen = () => {
  const history = useHistory();
  const [boxstate, setBoxState] = useBox();
  const [preciosGarantia, setPreciosGarantia] = useState();
  const [openModal, setOpenModal] = useState(false);
  const [openModalCarga, setOpenModalCarga] = useState(false);
  const [idEdit, setIdEdit] = useState(0);
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });

  const handleOpenModal = (id) => {
    setIdEdit(id);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const abrirCarga = () => {
    setOpenModalCarga(true);
  };

  const cerrarCarga = () => {
    setOpenModalCarga(false);
  };

  useEffect(() => {
    onExecute();
  }, [openModal]);

  const onExecute = () => {
    setLoader({ ...loader, mostrar: true });

    return new Promise((resolve, reject) => {
      setLoader({ ...loader, mostrar: true });
      request
        .get(`DashboardPostventa/PreciosGarantias`)
        .then((result) => {
          setLoader({ ...loader, mostrar: false });
          setPreciosGarantia(result);
          return;
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          reject(error);
          return;
        });
    });
  };

  return (
    <PlantillaScreen
      titulo={"CONFIGURACION DE PRECIOS DE GARANTIAS"}
      className={"montos-garantia-main-screen"}
      className_main={2}
    >
      <LoaderScreen loader={loader} />
      <div className="montos-garantia-actions">
        <div
          className="montos-garantia-actions-regresar"
          onClick={() => history.goBack()}
        >
          <ArrowBackIcon /> Regresar
        </div>
        <div className="buttons">
          <button
            className="montos-garantia-header-descargar-csv"
            onClick={() => abrirCarga()}
          >
            <AddCircleOutlineIcon /> Carga Masiva
          </button>

          {/* <button
            className="montos-garantia-header-agregar"
            onClick={() => handleOpenModal()}
          >
            <AddCircleOutlineIcon /> Agregar
          </button> */}
        </div>
      </div>
      {preciosGarantia && (
        <div className="contador-montos-garantia-encontrados">
          Garantías encontradas: {preciosGarantia.length}
        </div>
      )}
      <div className="montos-garantia">
        <div className="montos-garantia-container scroll">
          <table cellPadding={0} cellSpacing={0}>
            <thead>
              <tr>
                <th>Modelo</th>
                <th>
                  <div>Precio Venta Temprana</div>
                </th>
                <th>
                  <div>Precio Venta Tardia</div>
                </th>
                <th>
                  <div>Precio Fin de Garantia</div>
                </th>
                <th>
                  <div>Fecha Inicio</div>
                </th>
                <th>
                  <div>Vigencia</div>
                </th>
                <th>
                  <div>Editar</div>
                </th>
              </tr>
            </thead>
            <tbody>
              {preciosGarantia &&
                preciosGarantia.length > 0 &&
                preciosGarantia.map((item, index) => (
                  <tr key={index}>
                    <td>{item.modelo}</td>
                    <td
                      className={
                        item.venta_temprana === 0 ? "ta-center" : "ta-right"
                      }
                    >
                      {item.venta_temprana === 0
                        ? "Pendiente"
                        : FormatMoney(item.venta_temprana)}
                    </td>

                    <td
                      className={
                        item.venta_tardia === 0 ? "ta-center" : "ta-right"
                      }
                    >
                      {item.venta_tardia === 0
                        ? "Pendiente"
                        : FormatMoney(item.venta_tardia)}
                    </td>
                    <td
                      className={
                        item.venta_fin_garantia === 0 ? "ta-center" : "ta-right"
                      }
                    >
                      {item.venta_fin_garantia === 0
                        ? "Pendiente"
                        : FormatMoney(item.venta_fin_garantia)}
                    </td>
                    <td className="ta-center">{item.fecha_inicio}</td>
                    <td className="ta-center">{item.fecha_fin}</td>
                    <td>
                      <div className="imagenes-button" onClick={() => handleOpenModal(item.idprecio)} style={{ cursor: "pointer" }}>
                        {/* <AddPhotoAlternateIcon /> */}
                        Editar
                      </div>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>

      <AgregarMontoGarantiaModal open={openModal} onClose={handleCloseModal} idEdit={idEdit} />
      <CargaMasiva open={openModalCarga} onClose={cerrarCarga} preciosGarantia={preciosGarantia} onExecute={onExecute} />

    </PlantillaScreen>
  );
};
